import { QueryKey } from "@tanstack/react-query";

export const OPERATION_KEYS = {
  STAFF: "admin/staff",
  VESSEL: "admin/vessel",
  SUPPLY: "admin/supply",
  GET_ALL_STAFF: (params: unknown): QueryKey => [OPERATION_KEYS.STAFF, params],
  GET_STAFF_BY_ID: (id: string): QueryKey => [
    OPERATION_KEYS.STAFF,
    "detail",
    id,
  ],
  GET_STAFF_ACTIVITY_TODAY: (id: string): QueryKey => [
    OPERATION_KEYS.STAFF,
    "activity",
    id,
  ],
  GET_STAFF_WEEKLY_ACTIVITIES: (id: string, startDate?: string) => [
    "getStaffWeeklyActivities",
    id,
    startDate,
  ],
  GET_STAFF_CURRENT_STATUS_ACTIVITY: (id: string) => [
    "getStaffCurrentStatusActivity",
    id,
  ],
  GET_ALL_VESSEL: (params: unknown): QueryKey => [
    OPERATION_KEYS.VESSEL,
    params,
  ],
  GET_ALL_SUPPLY: (params: unknown): QueryKey => [
    OPERATION_KEYS.SUPPLY,
    params,
  ],
};
